export class ParcelQError extends Error {
  constructor(
    message: string,
    readonly code: string,
    readonly status = 500,
  ) {
    super(message);
    this.name = "ParcelQError";
  }
}

export const Errors = {
  Parcel_Not_Found: () => new ParcelQError("parcel not found", "PARCEL_NOT_FOUND", 404),
  Bundle_Invalid: () => new ParcelQError("invalid report bundle", "INVALID_BUNDLE", 400),
  Radius_Invalid: (Detail?: string) =>
    new ParcelQError(Detail || "invalid radius_miles", "INVALID_RADIUS", 400),
  Job_Not_Found: () => new ParcelQError("job not found", "JOB_NOT_FOUND", 404),
  Query_Missing: () => new ParcelQError("apn or address is required", "MISSING_QUERY", 400),
  Parcel_Not_Supported: (reason?: string) =>
    new ParcelQError(
      reason ? `parcel not supported: ${reason}` : "parcel not supported",
      "PARCEL_NOT_SUPPORTED",
      400,
    ),
  Payments_Required: () => new ParcelQError("payment required", "PAYMENT_REQUIRED", 400),
  Payment_Not_Found: () => new ParcelQError("payment session not found", "PAYMENT_NOT_FOUND", 400),
  Payment_Not_Paid: () => new ParcelQError("payment not completed", "PAYMENT_NOT_PAID", 402),
  Payment_Bundle_Mismatch: () =>
    new ParcelQError("payment bundle does not match request", "PAYMENT_BUNDLE_MISMATCH", 400),
  Payment_Query_Mismatch: (detail: string) =>
    new ParcelQError(detail, "PAYMENT_QUERY_MISMATCH", 400),
  Job_Forbidden: () => new ParcelQError("job not found", "JOB_FORBIDDEN", 404),
  Stripe_Not_Configured: () =>
    new ParcelQError("stripe is not configured", "STRIPE_NOT_CONFIGURED", 400),
};
